import { Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'
import styles from './NavLink.module.scss'

interface NavLinkProps {
  link: string
  title: string
  size?: 'large' | 'small'
}

const NavLink = ({ link = '', title, size }: NavLinkProps) => {
  const location = useLocation()
  const linkPath = link.split('?')[0]

  const active = location.pathname === linkPath

  const className = `${styles.navLink} ${active ? styles.active : ''}`
  return (
    <a href={link} className={className}>
      <Typography variant={size === 'small' ? 'body1' : 'h6'}>
        {title}
      </Typography>
    </a>
  )
}

export default NavLink
